import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges
} from '@angular/core';
import { Store } from '@ngrx/store';
import * as htmlmixed from 'codemirror/mode/htmlmixed/htmlmixed';
import * as moment from 'moment-timezone';
import { Observable } from 'rxjs/internal/Observable';
import { PreviewEditTemplateActions } from './state/preview-edit-template.actions';
import { PreviewEditTemplateSelectors } from './state/preview-edit-template.selectors';
import { PreviewEditTemplateService } from './state/preview-edit-template.service';

@Component({
    selector: 'preview-edit-source',
    templateUrl: './preview-edit-source.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class PreviewEditSourceComponent implements OnChanges {
    @Input() emailSource; // = '<p>My HTML</p> <comment label="test this"></comment> <p>Your HTML</p>';
    @Input() selectedUserName;
    @Input() selectedUserId;
    @Input() updatedModel;
    @Input() selectedTemplateId;
    @Input() isOnlyPreview;
    @Input() selectedTemplate;
    @Output() readonly isSourceChange = new EventEmitter<boolean>();
    @Output() readonly templateFileRefChange = new EventEmitter<string>();
    lineWrapping = true;
    autoCorrect = false;
    isSourceUpdated = false;
    isValidated$: Observable<any>;
    templateFileRef: string = undefined;
    emailSource$: Observable<any>;
    source: any;

    getCodeMirrorOptions(): any {
        return {
            lineWrapping: this.lineWrapping,
            lineNumbers: true,
            readOnly: this.isOnlyPreview,
            formatting : true,
            mode: 'htmlmixed',
            cursorHeight: 1,
            autofocus: true,
            extraKeys: {
            }
        };
    }

    ngOnChanges(changes: SimpleChanges) {
        if(changes.emailSource !== undefined) {
            this.source = this.emailSource;
        }
    }

    onChange(): void {
        this.isSourceUpdated = true;
    }

    onBlur(): void {
        if (this.isSourceUpdated) {
            const randomNumber = moment.now();
            if (this.templateFileRef === undefined) {
                this.templateFileRef = `${randomNumber}.tmp`;
            }
            const template = {
                templatePath: this.templateFileRef,
                fileSource: this.source,
                createIfNotExists: true
            };
            this.store.dispatch(PreviewEditTemplateActions
                .validateSource({
                    template,
                    userName: this.selectedUserName,
                    userId: this.selectedUserId,
                    fileName: this.templateFileRef,
                    updatedModel: this.updatedModel,
                    templateId: this.selectedTemplateId,
                    isConfirm: this.selectedTemplate !== undefined ? this.selectedTemplate.isConfirm : false
                }));
        }
    }

    constructor(private previewEditTemplateSelectors: PreviewEditTemplateSelectors,
                private store: Store<any>,
                private previewEditTemplateService: PreviewEditTemplateService) {
        this.isValidated$ = this.previewEditTemplateSelectors.selectGetValidatedSource();
        this.isValidated$.subscribe(canSave => {
            if (canSave) {
                this.isSourceUpdated = false;
                this.isSourceChange.emit(this.source);
                this.templateFileRefChange.emit(`${this.templateFileRef}`);
            }
        });
    }

    onAutoCorrect(): void {
        if (this.autoCorrect) {
            const matches = this.source.match(/(<body id="mailcontent"[^>]*>((.|[\n\r])*)<\/body>)/g);
            const htmlText = matches !== null ? matches[0] : this.source;
            this.emailSource$ = this.previewEditTemplateService.convertHtmlToXhtml(htmlText);
            this.emailSource$.subscribe(
                emailSource => {
                    if (emailSource !== null) {
                        const matches = emailSource.match(/(<body[^>]*>((.|[\n\r])*)<\/body>)/g);
                        this.source = this.source.replace(/(<body id="mailcontent"[^>]*>((.|[\n\r])*)<\/body>)/g, matches[0]);
                        this.autoCorrect = false;
                    }
                }
            );
        }
    }
}
